import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "state/store";

export interface WithdrawFundsModalState {
  show: boolean;
  autoOpenAchSection: boolean;
}

const initialState: WithdrawFundsModalState = {
  show: false,
  autoOpenAchSection: false,
};

export const withdrawFundsModalSlice = createSlice({
  name: "withdrawFundsModal",
  initialState,
  reducers: {
    showWithdrawFundsModal: (state) => {
      state.show = true;
      state.autoOpenAchSection = false;
    },
    showWithdrawFundsModalWithAchOpen: (state) => {
      state.show = true;
      state.autoOpenAchSection = true;
    },
    hideWithdrawFundsModal: (state) => {
      state.show = false;
      state.autoOpenAchSection = false;
    },
  },
});

export const { showWithdrawFundsModal, showWithdrawFundsModalWithAchOpen, hideWithdrawFundsModal } = withdrawFundsModalSlice.actions;

export const getWithdrawFundsModalState = (state: RootState): WithdrawFundsModalState =>
  state.withdrawFundsModal;

export default withdrawFundsModalSlice.reducer; 